import { mapGetters, mapActions } from 'vuex'
import BudgetSystemModule, { MODULE_NAME } from './index'

const BudgetSystemMixin = {
  namespaced: BudgetSystemModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(BudgetSystemModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(BudgetSystemModule.actions)) }
}

export default BudgetSystemMixin



// WEBPACK FOOTER //
// ./src/store/module/budgetsystem/mixin.js